import React from "react";
import "./eventModalHeader.sass";
import ModalDetailHeader from "../modalDetailHeader/modalDetailHeader";
import Tag from "../../atoms/tag/tag";
import EventDetails from "../../../stores/domainStore/pages/models/eventDetails";
import {EventDetailsHelper} from "../../../shared/eventDetailsHelper";
import {useTranslation} from "react-i18next";

export interface IEventModalHeaderProps {
  toggle: () => void;
  isLoading: boolean;
  eventDetails: EventDetails;
  isEnhancedCalendarEvent?: boolean;
}

const EventModalHeader: React.FC<IEventModalHeaderProps> = ({
  toggle,
  isLoading,
  eventDetails,
  isEnhancedCalendarEvent
}) => {
  const {t} = useTranslation(["translation", "event"]);
  const tagText = isEnhancedCalendarEvent
    ? t("event:labels.isFeatured")
    : t("event:labels.special");

  return (
    <ModalDetailHeader isLoading={isLoading} toggle={toggle}>
      <div className="header-container">
        <div className="header-column column-fixed">
          {EventDetailsHelper.getRecurringEventStatusIcon(eventDetails)}
        </div>
        <div className="header-column column-dynamic">
          <span>
            <span data-testid="eventDetailModalTitle">
              {eventDetails.title.text}
            </span>
            {eventDetails.isFeatured.value && (
              <Tag text={tagText} type="digital" />
            )}
          </span>
        </div>
      </div>
    </ModalDetailHeader>
  );
};

export default EventModalHeader;
